<template>
    <div class="min-h-screen flex items-center justify-center p-6 ct-bg-1--alt">
        <div class="w-full max-w-xl space-y-12 text-center">
            <img v-if="player.logo" :src="player.logo" alt="logo" class="h-12 mx-auto" />
            <EasyToolsIcon v-else class="h-8 mx-auto" />
            <div class="w-full space-y-8">
                <div class="space-y-6">
                    <p class="ct-text-1 text-3xl font-semibold">
                        {{ $t("r_player.counter.title") }}
                    </p>
                    <div class="rounded-lg ct-bg-2--subtle border ct-border-1 py-3 px-4 shadow-md">
                        <p class="ct-text-3 text-2xl text-center">
                            <cCounter :date="player.releaseAt" />
                        </p>
                    </div>
                </div>

                <div class="space-y-6">
                    <p class="ct-text-3 text-base">
                        {{ $t("r_player.access.need_help") }}
                        <a class="underline" href="mailto:hello@easy.tools">{{
                            $t("r_player.access.contact_us")
                        }}</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { EasyToolsIcon } from "@easy/ui/icons";
import cCounter from "@/views/shared/cCounter.vue";

export default {
    name: "PlayerCounter",
    components: {
        EasyToolsIcon,
        cCounter,
    },
    computed: {
        ...mapState("player/view", ["player"]),
    },
};
</script>
